import { render, staticRenderFns } from "./AppSortableTable.vue?vue&type=template&id=10d4faaa&"
import script from "./AppSortableTable.vue?vue&type=script&lang=ts&"
export * from "./AppSortableTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports